import React from "react";
import Speech from "./Speech";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <Speech />
    </div>
  );
}
